/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddFavorite201ResponseAllOfData } from './AddFavorite201ResponseAllOfData';
import {
    AddFavorite201ResponseAllOfDataFromJSON,
    AddFavorite201ResponseAllOfDataFromJSONTyped,
    AddFavorite201ResponseAllOfDataToJSON,
} from './AddFavorite201ResponseAllOfData';

/**
 * 
 * @export
 * @interface AddFavorite201ResponseAllOf
 */
export interface AddFavorite201ResponseAllOf {
    /**
     * 
     * @type {AddFavorite201ResponseAllOfData}
     * @memberof AddFavorite201ResponseAllOf
     */
    data: AddFavorite201ResponseAllOfData;
}

/**
 * Check if a given object implements the AddFavorite201ResponseAllOf interface.
 */
export function instanceOfAddFavorite201ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function AddFavorite201ResponseAllOfFromJSON(json: any): AddFavorite201ResponseAllOf {
    return AddFavorite201ResponseAllOfFromJSONTyped(json, false);
}

export function AddFavorite201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFavorite201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': AddFavorite201ResponseAllOfDataFromJSON(json['data']),
    };
}

export function AddFavorite201ResponseAllOfToJSON(value?: AddFavorite201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': AddFavorite201ResponseAllOfDataToJSON(value.data),
    };
}

